import api from '../../api'

const recurrenceAPI = api.create('recurrence')

const get = async ({ taxInvoiceId = '', ...params }) => {
  return await recurrenceAPI.get(
    `/tax_invoice/service_tax_invoices/${taxInvoiceId}`,
    { params },
  )
}

const downloadCsv = async ({ ...params }) => {
  return await recurrenceAPI.get(`/tax_invoice/service_tax_invoices.csv/`, {
    params,
  })
}

const attach = async ({ invoiceId = '', ...data }) => {
  return await recurrenceAPI.post(
    `/invoices/${invoiceId}/service_tax_invoice/attach`,
    data,
  )
}

const create = async ({ invoiceId }) => {
  return await recurrenceAPI.post(`/invoices/${invoiceId}/service_tax_invoice/`)
}

const cancel = async ({ taxInvoiceId, ...params }) => {
  return await recurrenceAPI.post(
    `tax_invoice/service_tax_invoices/${taxInvoiceId}/cancel`,
    params,
  )
}

const download = async ({ taxInvoiceId }) => {
  return await recurrenceAPI.get(
    `tax_invoice/service_tax_invoices/${taxInvoiceId}/download`,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/pdf',
      },
      responseType: 'arraybuffer',
    },
  )
}

export default { get, attach, cancel, create, download, downloadCsv }
